import React from "react"
import PropTypes from "prop-types"

import GetCycleWizard from "@irati/insights/apollo/query/wizard/Cycle"
import id from "@irati/utils/id"
import {AccordionItem} from "@irati/ui/src/Accordion"
import {injectIntl} from "@irati/utils/lang"

import {QuestionManager} from "../Question"
import QuestionManagerCustom from "../Question/QuestionManagerCustom"
import {SpacedMarkdown} from "./SpacedMarkdown"
import isCycleCustom from "../../../helpers/cycle/isCycleCustom"

const QuestionLibrary = ({formatMessage, disabled, ...props}) => {
  const idNamespace = id("QuestionLibrary", props)
  return (
    <GetCycleWizard useLoader>
      {({schedule}) => {
        const {interest, questions: {total: questionCount}} = schedule

        if (isCycleCustom(schedule)) return <QuestionManagerCustom disabled={disabled} />

        return (
          <>
            <SpacedMarkdown
              id={id("questionLibraryDesc", idNamespace)}
              source={formatMessage({id: `${interest.contentId}.questionLibraryDescription`}, {questionCount})} />
            <AccordionItem
              isInner
              id={id("questionManager", idNamespace)}
              title={formatMessage({id: `${interest.contentId}.questionLibraryTitle`}, {questionCount})}>

              <SpacedMarkdown
                id={id("questionLibrarySecondaryDesc", idNamespace)}
                source={formatMessage({id: `${interest.contentId}.secondaryQuestionLibraryDescription`})} />

              <QuestionManager
                id={id("questionManager", idNamespace)}
                interest={interest} />
            </AccordionItem>
          </>
        )
      }}
    </GetCycleWizard>
  )
}

QuestionLibrary.propTypes = {
  formatMessage: PropTypes.func.isRequired,
  disabled: PropTypes.bool
}

QuestionLibrary.defaultProps = {
  disabled: false
}

export default injectIntl(QuestionLibrary)
